import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import SlideDialogV from '../../../components/common/SlideDialogV';
import CheckBox from '../../../components/common/CheckBox';

const AiParsedDialog = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation('previousEmployment');
  const [isChecked, setIsChecked] = useState(false);

  const handleConfirm = () => {
    if (isChecked) {
      onConfirm();
    }
  };

  const handleClose = () => {
    setIsChecked(false);
    onClose();
  };

  const buttons = [
    {
      label: t('aiParsedDialog.agreeButton'),
      onClick: handleConfirm,
      color: 'primary',
      disabled: !isChecked,
    },
  ];

  const checkboxComponent = (
    <div style={{ marginBottom: '16px' }}>
      <CheckBox
        checked={isChecked}
        onChange={() => setIsChecked(!isChecked)}
        label={t('aiParsedDialog.checkLabel')}
        style={{ alignItems: 'flex-start' }}
      />
    </div>
  );

  return (
    <SlideDialogV
      isOpen={isOpen}
      onClose={handleClose}
      title={t('aiParsedDialog.title')}
      description={t('aiParsedDialog.description')}
      buttons={buttons}
      innertComponent={checkboxComponent}
    />
  );
};

export default AiParsedDialog;
